module.exports = __webpack_public_path__ + "img/pitch-deck-icon.6fb9234c.svg";